import { useEffect, useState } from "react";
import { Volume2, VolumeX, Vibrate, VibrateOff } from "lucide-react";
import { toast } from "sonner";
import { isMuted, setMutedGlobal, hapticsOn, setHaptics, canVibrate, buzz, BUZZ } from "@/lib/fx";

export const FxToggles = () => {
  const [muted, setMuted] = useState(isMuted());
  const [haptic, setHaptic] = useState(hapticsOn());
  useEffect(() => {
    const sync = () => { setMuted(isMuted()); setHaptic(hapticsOn()); };
    window.addEventListener("naevo-fx-change", sync);
    return () => window.removeEventListener("naevo-fx-change", sync);
  }, []);
  const btn = "h-9 w-9 rounded-full flex items-center justify-center border border-gold/25 bg-black/40 text-gold hover:border-gold/60 transition-colors";
  return (
    <div className="flex items-center gap-1.5" data-testid="fx-toggles">
      <button className={btn} onClick={() => { setMutedGlobal(!muted); toast(muted ? "Casino sounds on" : "Casino sounds off", { id: "fx" }); }}
        aria-label="Toggle sound" title={muted ? "Sound off" : "Sound on"} data-testid="fx-sound-toggle">
        {muted ? <VolumeX className="h-4 w-4 text-white/50" /> : <Volume2 className="h-4 w-4" />}
      </button>
      <button className={btn} onClick={() => {
        const next = !haptic;
        setHaptics(next);
        if (next) buzz(BUZZ.win);
        toast(next ? (canVibrate() ? "Vibration on" : "Vibration on — your browser doesn't support it (iPhone Safari)") : "Vibration off", { id: "fx" });
      }} aria-label="Toggle vibration" title={haptic ? "Vibration on" : "Vibration off"} data-testid="fx-haptics-toggle">
        {haptic ? <Vibrate className="h-4 w-4" /> : <VibrateOff className="h-4 w-4 text-white/50" />}
      </button>
    </div>
  );
};
